import { GetCurrentUserResponse, User } from 'compliance-api';

export const checkIfTaskAssignedToUser = (
  currentUser: GetCurrentUserResponse | undefined,
  users: User[],
) => users.some(({ id }) => currentUser?.user?.id === id);
